/**
 * Indeed Disposition Sync status enum (partnerDisposition.send dispositionStatus).
 * Full set per docs.indeed.com Disposition Sync API.
 */
export const INDEED_DISPOSITIONS = [
  'NEW',
  'REVIEW',
  'LIKED',
  'CONTACTED',
  'SCREEN',
  'ASSESS_QUALIFICATIONS',
  'POSITIVELY_SCREENED',
  'INTERVIEW',
  'VERIFY_ELIGIBILITY',
  'BACKGROUND_CHECK',
  'OFFER_MADE',
  'OFFER_DECLINED',
  'HIRED',
  'ONBOARDED',
  'NOT_SELECTED',
  'WITHDRAWN',
  'INCOMPLETE',
  'UNABLE_TO_MAP',
  'JOB_CLOSED',
  'JOB_INACTIVE',
  'DROPPED_DUPLICATE',
  'DROPPED_FRAUD_SPAM',
  'DROPPED_JOB_EXPIRED',
  'DROPPED_OTHER',
] as const;

export type IndeedDisposition = (typeof INDEED_DISPOSITIONS)[number];

export interface PipelineStageDef {
  key: string;
  label: string;
  sortOrder: number;
  indeedDisposition: IndeedDisposition;
  isTerminal: boolean;
}

/**
 * The SDR hiring pipeline. Single source of truth — the 0002 seed migration and
 * the UI stage ordering are generated from / must match this list.
 */
export const PIPELINE_STAGES: readonly PipelineStageDef[] = [
  { key: 'new', label: 'New', sortOrder: 10, indeedDisposition: 'NEW', isTerminal: false },
  { key: 'review', label: 'Review', sortOrder: 20, indeedDisposition: 'REVIEW', isTerminal: false },
  { key: 'contacted', label: 'Contacted', sortOrder: 30, indeedDisposition: 'CONTACTED', isTerminal: false },
  { key: 'screen', label: 'Phone Screen', sortOrder: 40, indeedDisposition: 'SCREEN', isTerminal: false },
  { key: 'interview', label: 'Interview', sortOrder: 50, indeedDisposition: 'INTERVIEW', isTerminal: false },
  { key: 'offer', label: 'Offer', sortOrder: 60, indeedDisposition: 'OFFER_MADE', isTerminal: false },
  { key: 'hired', label: 'Hired', sortOrder: 70, indeedDisposition: 'HIRED', isTerminal: true },
  { key: 'rejected', label: 'Rejected', sortOrder: 80, indeedDisposition: 'NOT_SELECTED', isTerminal: true },
  { key: 'withdrawn', label: 'Withdrawn', sortOrder: 90, indeedDisposition: 'WITHDRAWN', isTerminal: true },
] as const;

export type StageKey = (typeof PIPELINE_STAGES)[number]['key'];

export function stageToDisposition(stageKey: string): IndeedDisposition | null {
  const stage = PIPELINE_STAGES.find((s) => s.key === stageKey);
  return stage ? stage.indeedDisposition : null;
}
